import { createContext, useContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem("qs_dark") === "1"; } catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem("qs_dark", dark ? "1" : "0"); } catch {}
    document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
  }, [dark]);

  const toggle = () => setDark((d) => !d);

  // All design tokens in one place
  const t = dark ? {
    bg:        "#0f1117",
    bg2:       "#16181f",
    bg3:       "#1e2028",
    bgHov:     "#1e2028",
    border:    "#2a2d38",
    border2:   "#333747",
    text:      "#f0eff0",
    text2:     "#9a9ba8",
    text3:     "#606270",
    accent:    "#e8e5df",
    accentBg:  "#1e2028",
    inputBg:   "#1a1c24",
    cardBg:    "#16181f",
    navBg:     "rgba(15,17,23,0.92)",
    tag:       "#242630",
    tagText:   "#8a8b98",
    primary:   "#f0eff0",
    primaryFg: "#0f1117",
  } : {
    bg:        "#fcfbf9",
    bg2:       "#f4f2ef",
    bg3:       "#f9f7f5",
    bgHov:     "#faf9f7",
    border:    "#e8e5e0",
    border2:   "#ddd",
    text:      "#0f1117",
    text2:     "#666",
    text3:     "#aaa",
    accent:    "#0f1117",
    accentBg:  "#f4f2ef",
    inputBg:   "#faf9f7",
    cardBg:    "#ffffff",
    navBg:     "rgba(252,251,249,0.94)",
    tag:       "#f1f0ee",
    tagText:   "#555",
    primary:   "#0f1117",
    primaryFg: "#ffffff",
  };

  return (
    <ThemeContext.Provider value={{ dark, toggle, t }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
